import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { IControlOption } from '@app/shared';
import { CountryISO } from 'ngx-intl-phone-input';

/*
 */
@Component({
  selector: 'app-auth-input-field',
  templateUrl: './auth-input-field.component.html',
  styleUrls: ['./auth-input-field.component.scss'],
})
export class AuthInputFieldComponent implements OnInit {
  @ViewChild('inputElement') inputElement: ElementRef;

  @Input() form: UntypedFormGroup;
  @Input() controlName: string;

  @Input() set options(options: IControlOption[]) {
    this._options = options;
  }

  public get options() {
    return this._options;
  }

  @Input() set type(type: string) {
    this._type = type;
  }

  get type(): string {
    return this._type;
  }

  @Input() placeholder: string;
  @Input() dataTestName: string;
  @Input() showValidation: boolean;
  @Input() error_message: string = null;
  @Input() displayLeftIco = true;
  @Input() localization: 'en' | 'ru' = 'en';
  @Input() validation: string = null;
  private val_regexp: RegExp = null;

  @Input() set countryCode(value: CountryISO) {
    if (value) {
      this._countryCode = value;
    }
  }

  public get countryCode() {
    return this._countryCode;
  }

  // tslint:disable-next-line: no-output-on-prefix
  @Output() onEnter = new EventEmitter<boolean>();
  @Output() onChanged = new EventEmitter<any>();

  public focusField = false;
  public showPassword = false;
  public _type;
  public _options;
  public _countryCode: CountryISO;

  constructor() {}

  ngOnInit() {
    if (this.validation) {
      this.val_regexp = new RegExp(this.validation, 'i');
    }
  }

  /*
   */
  public placeholderValue(): string {
    return this.focusField ? '' : this.placeholder;
  }

  public isCountry(): boolean {
    return this.type === 'country';
  }

  public isPhone(): boolean {
    return this.type === 'phone';
  }

  public isPassword(): boolean {
    return this.type === 'password';
  }

  public isAgreement(): boolean {
    return this.type === 'agreement';
  }

  public get warnField(): boolean {
    return this.form.controls[this.controlName].invalid;
  }

  public toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }

  public get message() {
    return this.error_message || null;
  }

  public onChange(val: any) {
    this.onChanged.emit(val);
  }

  public onBeforeInput(e: InputEvent) {
    if (!e.inputType.startsWith('insert') || e.inputType === 'insertLineBreak') {
      return;
    }

    const input = this.inputElement.nativeElement;
    const val = input.value;

    const insert = e.data || '';

    if (!this.val_regexp || !this.validation) {
      return;
    }

    if (!this.val_regexp.test(insert)) {
      e.preventDefault();
    }
  }

  public onInput(e: any) {
    this.inputElement.nativeElement.value = e.target.value || '';
  }
}
